import { useCallback, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { JobsService } from '../services';

export const useJobList = ({ jobType } = {}) => {
  const [filters, setFilters] = useState({
    page: 1,
    limit: 15,
    sortField: 'createdAt',
    sortOrder: 'desc',
    jobStatus: 'all',
    searchText: '',
    profession: '',
    subProfession: '',
    specialtyRdh: '',
    specialtyDa: '',
    workerClassification: '',
    ram: '',
    dsoName: '',
    dsoManager: '',
    state: '',
    startDate: null,
    endDate: null,
    dsoRamIds: '',
    dsoId: '',
    dateRange: {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  });

  const { data: response, isLoading, isFetching } = useQuery({
    queryKey: ['fetchJobList', filters, jobType],
    queryFn: () => JobsService.getJobList(filters, jobType),
    retry: false,
  });

  const data = response?.response || [];
  const total = response?.total || 0;
  const totalFiltered = response?.totalFiltered || 0;
  const totalPages = Math.ceil(totalFiltered / filters.limit) || 1;

  const handleFilterChanged = useCallback((type, value) => {
    setFilters((prev) => ({ ...prev, [type]: value, page: 1 }));
  }, []);

  const handlePageChanged = useCallback((page) => {
    setFilters((prev) => ({ ...prev, page }));
  }, []);

  const handleSortChanged = useCallback((selectedColumn, sortDirection) => {
    setFilters((prev) => ({
      ...prev,
      sortField: selectedColumn.sortField,
      sortOrder: sortDirection,
    }));
  }, []);

  const queryClient = useQueryClient();
  const reloadJobs = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['fetchJobList'] });
  }, [queryClient]);

  return {
    data,
    filters,
    isLoading,
    isFetching,
    total,
    totalFiltered,
    totalPages,
    handleFilterChanged,
    handlePageChanged,
    handleSortChanged,
    reloadJobs,
  };
};
